import React, { useContext, useEffect, useState } from 'react'
import { Page_settings } from '../../config/page_settings'
import strings from '../../lang/strings'
import AppInput from '../../components/control/custom_input/app_input'
import PerfectScrollbar from 'react-perfect-scrollbar'
import TableHeaderBetting from '../../components/control/table/table_header_betting'
import TableCell from '../../components/control/table/table_cell'
import TableCellBettingResult from '../../components/control/table/table_cell_betting_result'
import { ceil, customDateFormat, formatNumber, string } from '../../helper/common'


const BettingBoxArea = ({ data, onBettingDataUpdate }) => {
    const context = useContext(Page_settings);
    const [yearList, setYearList] = useState([]);
    const [roundList, setRoundList] = useState([]);
    const [roundListAll, setRoundListAll] = useState([]);
    const [year, setYear] = useState(0);
    const [round, setRound] = useState(0);
    const [kindList, setKindList] = useState([]);
    const [loaded, setLoaded] = useState(false);
    const [error, setError]  = useState('');
    const defaultBettingData = {
        kind: 0,
        selGameCnt: 0,
        expectRate: 1.0,
        amount: 50000,
        expectCoin: 0,
        expectGainRate: 0,
        selListAll: []
    };

    const [bettingDatas, setBettingDatas] = useState([{ ...defaultBettingData }]);

    const selectYear = (year) => setYear(year);

    const selectRound = (round) => setRound(round);

    useEffect(() => {
        initPicker();
        if (data) {
            initMyData();
        }
    }, []);

    const initPicker = () => {
        context.post(
            'data/sport_list',
            { dat_id: data?.other_purchased === 1 ? data.dat_id : 0 },
            (response) => {
                const yearL = response.year;
                if (!yearL.length) return;
                const yearT = data ? data.dat_s_year : yearL[0].year;
                const roundL = response.round;
                const roundL1 = roundL.filter((item) => item.year === yearT);
                if (!roundL1.length || !roundL1[0].round.length) return;
                const roundT = data ? data.dat_s_round : roundL1[0].round[0].round;

                setYear(yearT);
                setYearList(yearL);
                setRoundListAll(roundL);
                setRoundList(roundL1[0].round);
                setRound(roundT);
                setKindList(response.kind);
                setLoaded(true);
            }
        );
    };

    const initMyData = () => {
        context.post('data/game_list_new', { uid: data.dat_id }, response => {
            if (!response.data || response.data.length === 0) return;
            const tmp = response.data.map(bet => ({
                ...defaultBettingData,
                amount: parseInt(bet.price),
                expectRate: bet.bae,
                expectCoin : parseInt(bet.price * bet.bae),
                kind: bet.kind,
                game_list: bet.game.map(item => ({
                    ...item,
                    sel: item.dg_i_win == 1 ? 0 : item.dg_i_tie == 1 ? 1 : item.dg_i_loss == 1 ? 2 : -1,
                    ans: item.hit_type ?? -1
                })),
                selGameCnt : (bet.game ?? []).length
            }));
            setBettingDatas(tmp);
        });
    }

    const addBettingData = () => {
        setBettingDatas((prev) => [...prev, { ...defaultBettingData }]);
    };

    const bettingDataUpdate = (index, newItem) => {
        setBettingDatas((prev) =>
            prev.map((item, i) => (i === index ? { ...item, ...newItem } : item))
        );
    };

    const resetBettingData = (index) => {
        setBettingDatas((prev) =>
            prev.map((item, i) => (i === index ? { ...defaultBettingData } : item))
        );
    };

    const deleteBettingData = (index) => {
        setBettingDatas(prev => prev.filter((_, i) => i !== index));
    };

    useEffect(() => {
        if (data) return;
        const hasInvalidBet = bettingDatas.some(betData => parseInt(betData.amount) < 5000);
        let totalAmount = 0;
    
        bettingDatas.forEach((betData) => {
            const betAmount = parseInt(betData.amount);
            totalAmount += betAmount;
        });
        if (hasInvalidBet) {
            setError('각 베팅금액은 최소 5,000원 이상이어야 합니다.');
        } else if (totalAmount > 100000) {
            setError('베팅금액 총합은 10만원 이내로 설정이 가능합니다.');
        } else {
            setError('');
        }
        
        updateBettingData();
    }, [bettingDatas]);

    const updateBettingData = () => {
        let totalAmount = 0;
        let hasInvalidBet = false;
        
        bettingDatas.forEach((betData) => {
            const betAmount = parseInt(betData.amount);
            totalAmount += betAmount;
        
            if (betAmount < 5000) {
                hasInvalidBet = true;
            }
        });
        

        if ( bettingDatas.some((data) => data.selListAll.length === 0) || hasInvalidBet || totalAmount > 100000 ) {
            if (onBettingDataUpdate) {onBettingDataUpdate(null);}
            return;
        }

        let start = '';
        let updateData = {
            year: year,
            round: round
        };
        let data = [];
        bettingDatas.forEach((betData, index) => {
            let list = [];
            let bae = 1;
            let price = parseInt(betData.amount || 0);

            betData.selListAll.forEach((item) => {
                if (start === '' || start > item.round_end) start = item.round_end;
                bae *= parseFloat(
                    item.sel === 0 ? item.home_dividend_rate 
                    : item.sel === 1 ? item.no_odds 
                    : item.away_dividend_rate
                );
                list.push({
                    id: item.id,
                    kind: item.sport_id,
                    win: item.sel === 0 ? 1 : 0,
                    tie: item.sel === 1 ? 1 : 0,
                    loss: item.sel === 2 ? 1 : 0,
                    home_rate : item.home_dividend_rate,
                    no_odds_rate : item.no_odds,
                    away_rate : item.away_dividend_rate
                })

            });
    
            bae = ceil(bae);
    
            data.push({
                list : list,
                price : price,
                bae : bae,
                kind : betData.kind || 0
            })
        });
    
        updateData["start"] = start; //
        updateData['data'] = data;
        if (onBettingDataUpdate) {
            onBettingDataUpdate(updateData);
        }
    };
    

    return (
        <React.Fragment>
            {loaded && bettingDatas.map((bettingData, index) => (
                <BettingBoxUnit
                    key={index}
                    title={index === 0 ? strings.main_power : `${strings.sub_power} ${index}`}
                    index={index}
                    yearList={yearList}
                    roundList={roundList}
                    kindList={kindList}
                    year={year}
                    round={round}
                    setYear={selectYear}
                    setRound={selectRound}
                    disabled={data}
                    data={data}
                    bettingData={bettingData}
                    updateBettingData={(newItem) => bettingDataUpdate(index, newItem)}
                    resetBettingData = {() => resetBettingData(index)}
                    deleteBettingData={() => deleteBettingData(index)} 
                    error={error}
                />
            ))}
            {!data && loaded && bettingDatas.length < 10 && (
                <div
                    className="v-sub-power fs-18 sm-fs-16 f-b color-3a3335 mt-12 sm-mt-15 ph-10 cursor-point"
                    onClick={addBettingData}
                >
                    <img className="mr-10" src="/assets/image/plus2.png" alt="" width={20} />
                    {strings.add_sub_power}
                </div>
            )}
        </React.Fragment>
    );
};

export default BettingBoxArea;



const BettingBoxUnit = (props) => {
    const tbHeaders = [
        {
            name: strings.number,
            class: 'td-pro-betting-num',
        },
        {
            name: strings.game_date,
            class: 'td-pro-betting-game-date',
        },
        {
            name: strings.game_type,
            class: 'td-pro-game-ty',
        },
        {
            name: strings.league,
            class: 'td-pro-betting-league',
        },
        {
            name: strings.betting_line,
            class: 'td-pro-betting-line',
            is_result: true
        }
    ]

    const gameTypeList = [strings.normal, strings.handycup, strings.endover, strings.win1loss, strings.evenorodd, strings.firsthalf]

    const context = useContext(Page_settings);
    const { kind, selGameCnt, expectRate, amount, expectCoin, expectGainRate } = props.bettingData;
    let [selListAll, setSelListAll] = useState([])
    let [bettingDataList, setBettingDataList] = useState([])
    useEffect(() => {
        initData(props.year, props.round, kind, props.index, true);
        props.updateBettingData({ kind });
    }, []);

    useEffect(() => {
        initData(props.year, props.round, kind, props.index, false);
        props.updateBettingData({ kind });
    }, [kind, props.round, props.year]);

    const initData = (year, round, kind, type, init = false) => {
        const data = props.data;
        context.post('data/get_toto_list', { year: year, round: round, sport: kind, dat_id: (data && data.other_purchased == 1) ? data.dat_id : 0 },
            response => {
                let list = response.list
                if (init && data) {
                    context.post('data/game_list', { uid: data.dat_id, type: type },
                        res => {
                            let game_list = res.game_list
                            for (let i = 0; i < list.length; i++) {
                                let gameT = game_list.filter((item) => { return item.id === list[i].id })
                                if (gameT.length > 0) {
                                    if (gameT[0].dg_i_win == 1) {
                                        list[i].sel = 0
                                    } else if (gameT[0].dg_i_tie == 1) {
                                        list[i].sel = 1
                                    } else if (gameT[0].dg_i_loss == 1) {
                                        list[i].sel = 2
                                    } else {
                                        list[i].sel = -1
                                    }
                                }
                                let gameS = game_list.filter((item) => { return item.id !== list[i].id && item.home_id === list[i].home_id && item.away_id === list[i].away_id && (item.dg_i_win == 1 || item.dg_i_tie == 1 || item.dg_i_loss == 1) })
                                if (gameS.length > 0) list[i].disable = true
                            }
                            setBettingDataList(list)
                            setSelListAll(list.filter((item) => { return item.sel > -1 }))
                        }
                    )
                } else {
                    for (let i = 0; i < list.length; i++) {
                        let gameT = selListAll.filter((item) => { return item.id === list[i].id });
                        list[i].sel = gameT.length > 0 ? gameT[0].sel : -1
                        let gameS = selListAll.filter((item) => { return item.id !== list[i].id && item.home_id === list[i].home_id && item.away_id === list[i].away_id && (item.dg_i_win == 1 || item.dg_i_tie == 1 || item.dg_i_loss == 1) });
                        if (gameS.length > 0) list[i].disable = true
                    }
                    setBettingDataList(list)
                }
            }
        )
    }

    const onSelChange = (val, index) => {
        if (props.disabled) return
        const betting = bettingDataList[index];
        if (betting.disable) return
        const dis_select = betting.sel === val
        setBettingDataList(prev => prev.map((it, idx) => {
            if (it.home_id === betting.home_id && it.away_id === betting.away_id && idx !== index) {
                it.disable = !dis_select
            }
            if (idx === index) {
                it.sel = it.sel === val ? -1 : val
                if (it.sel > -1) {
                    const itemT = selListAll.filter((item) => { return item.id == it.id })
                    if (itemT.length === 0) {
                        setSelListAll(prev => [...prev, it])
                    } else {
                        setSelListAll(prev => prev.map((tt) => {
                            if (tt.id == it.id) tt.sel = it.sel
                            return tt
                        }))
                    }
                } else {
                    setSelListAll(prev => prev.filter((item) => { return item.id != it.id }))
                }
            }
            return it
        }))
    }

    useEffect(() => {
        let gameCnt = selListAll.length
        let betting = 1
        for (let i = 0; i < gameCnt; i++) {
            betting *= parseFloat(selListAll[i].sel === 0 ? selListAll[i].home_dividend_rate : selListAll[i].sel === 1 ? selListAll[i].no_odds : selListAll[i].away_dividend_rate)
        }
        betting = Math.ceil(parseFloat(betting) * 10) / 10;
        let hit_val = parseInt(betting * amount)
        props.updateBettingData({
            selGameCnt: gameCnt,
            expectRate: betting,
            expectCoin: hit_val,
            expectGainRate: parseInt(betting * 100),
            selListAll: selListAll
        });
    }, [selListAll, amount])

    const reset = () => {
        setBettingDataList(prev => prev.map((it, idx) => {
            it.sel = -1
            it.disable = false
            return it
        }))
        setSelListAll([]);
        props.resetBettingData();

    }

    const getGameTypeClass = (type) => {
        if (type == 1) {
          return 'color-e45a5a'
        } else if (type == 2) {
          return 'color-3a6d99'
        } else if (type == 3) {
          return 'color-9c39cf'
        } else {
          return 'color-3a3335'
        }
      }

      
    return (
        <React.Fragment>
            <div className='d-flex al-header mt-12 sm-mt-15' style={{justifyContent : 'space-between', paddingRight : '40px'}}>
                <div className='fs-18 sm-fs-16 f-b'>{props.title}</div>
                {
                    props.index > 0 && (
                        <div className='fs-18 sm-fs-16 f-b color-3a3335 cursor-point' onClick={() => props.deleteBettingData?.()}>
                        <img className='mr-10' src={'/assets/image/close.png'} alt='' width={20} />
                        {strings.del_sub_power}
                        </div>
                    )
                }

            </div>
 
            <div className=''>
                <div className="data-filter-area d-flex mt-12 sm-mt-15 pl-40 sm-pl-18">
                    {props.index === 0 && (
                        <>
                            <select
                                disabled={props.disabled}
                                className="data-filter-select pr-60 sm-pr-8 fs-16 sm-fs-14 f-sb"
                                value={props.year}
                                onChange={(e) => props.setYear(e.target.value)}
                            >
                                {props.yearList.map((it, idx) => (
                                    <option value={it.year} key={idx}>
                                        {it.year}
                                        {strings.year}
                                    </option>
                                ))}
                            </select>
                            <select
                                disabled={props.disabled}
                                className="data-filter-select mh-60 sm-mh-12 pr-60 sm-pr-8 fs-16 sm-fs-14 f-sb"
                                value={props.round}
                                onChange={(e) => props.setRound(e.target.value)}
                            >
                                {props.roundList.map((it, idx) => (
                                    <option value={it.round} key={idx}>
                                        {it.round}
                                        {strings.times}
                                    </option>
                                ))}
                            </select>
                        </>
                    )}
                    <select
                        disabled={props.disabled}
                        className="data-filter-select pr-60 sm-pr-8 fs-16 sm-fs-14 f-sb"
                        value={kind}
                        onChange={(e) => props.updateBettingData({ kind: e.target.value })}
                    >
                        {props.kindList.map((it, idx) => (
                            <option value={it.sk_id} key={idx}>
                                {it.sk_name}
                            </option>
                        ))}
                    </select>
                </div>
                <div className='analyst_register bd-0 pt-20 sm-pt-40 sm-ph-15'>
                    <div className='shadow-div position-relative'>
                        <PerfectScrollbar className='div_sale div_game'>
                            <TableHeaderBetting className={'td-pro-betting-header'} headers={tbHeaders} />
                            {
                                bettingDataList.map((info, index) => {
                                    return (
                                        <div key={index} className={'tb-row-betting tb-row-betting1' + (info.disable ? ' tb-row-disabled' : '')}>
                                            <TableCell
                                                value={info.btm_match_seq}
                                                className={tbHeaders[0].class + ' td-cell-primary'}
                                                center={tbHeaders[0].center}
                                                child={null}
                                            />
                                            <TableCell
                                                value={customDateFormat(info.round_start, true)}
                                                className={tbHeaders[1].class + ' whitespace-pre-line td-cell-primary'}
                                                center={tbHeaders[1].center}
                                                child={null}
                                            />
                                            <TableCell
                                                value={gameTypeList[info.betting_type]}
                                                className={tbHeaders[2].class + ' td-cell-primary'}
                                                center={tbHeaders[2].center}
                                                child={
                                                    <div className={'w-100 text-center fs-16 sm-fs-14 f-m ' + getGameTypeClass(info.betting_type)}>{gameTypeList[info.betting_type]}</div>
                                                }
                                            />
                                            <TableCell
                                                value={info.league_name}
                                                className={tbHeaders[3].class + ' td-cell-primary'}
                                                center={tbHeaders[3].center}
                                                child={null}
                                            />
                                            <TableCellBettingResult
                                                betting_type={info.betting_type}
                                                home={info.home_name}
                                                away={info.away_name}
                                                winScore={info.home_dividend_rate}
                                                winUp={info.prev_home_dividend_rate}
                                                loseScore={info.away_dividend_rate}
                                                loseUp={info.prev_away_dividend_rate}
                                                drawScore={info.no_odds}
                                                drawUp={info.prev_no_odds}
                                                handi={info.handicap_standard}
                                                uo={info.uo_standard}
                                                selected={info.sel}
                                                ans={-1}
                                                className={tbHeaders[4].class + ' td-cell-primary td-cell-border'}
                                                center={tbHeaders[4].center}
                                                child={null}
                                                onSelectChange={(val) => {
                                                    onSelChange(val, index)
                                                }}
                                            />
                                        </div>
                                    )
                                })
                            }
                        </PerfectScrollbar>
                    </div>
                    <div className='div-betting-info d-flex-block pv-48 sm-pv-20 ph-20 sm-ph-30 align-items-center'>
                        <div className='d-block flex-full'>
                            <div className='flex-full d-center'>
                                <div className='fs-16 sm-fs-14 f-sb color-3a3335'>{strings.selected_game_count}</div>
                                <div className='fs-16 sm-fs-14 f-b color-e45a5a flex-full text-right'>{string.Format(strings.format_game_count, selGameCnt)}</div>
                            </div>
                            <div className='flex-full d-center mt-8'>
                                <div className='fs-16 sm-fs-14 color-3a3335 f-b'>{strings.expectant_rate}</div>
                                <div className='fs-16 sm-fs-14 f-b color-e45a5a flex-full text-right'>{string.Format(strings.format_rate, expectRate)}</div>
                            </div>
                        </div>
                        <div className='d-block flex-full pl-70 sm-pl-0 sm-mt-30'>
                            <div className='flex-full f-sb d-flex align-items-center position-relative '>
                                <div className='fs-16 sm-fs-14 color-3a3335 flex-full'>{strings.betting_amount}</div>
                                <AppInput disable={props.disabled} center={true} className={'betting-price-input fs-16 sm-fs-14'} errorMsg={''} placeholder={'10,000'} inputType={'text'} value={formatNumber(amount)} onChange={(v) => {
                                    const numericValue = Number(v.replace(/,/g, '')) || 0;
                                    props.updateBettingData({ amount: numericValue });
                                }}></AppInput>
                                <div className={'betting-box-amount-error invalid-feedback ' + (props.error !== '' ? 'error' : '')}>{props.error ?? ''}</div>
                            </div>
                            <div className='flex-full d-center mt-8 sm-mt-5'>
                                <div className='fs-16 sm-fs-14 color-3a3335 f-b'>{strings.expectant_amount}</div>
                                <div className='fs-16 sm-fs-14 f-b color-e45a5a flex-full text-right'>{string.Format(strings.format_won, formatNumber(expectCoin))}</div>
                            </div>
                        </div>
                        <div className='d-block flex-full pl-70 sm-pl-0'>
                            <div className='flex-full d-flex justify-content-end'>
                                <div className='betting-reset d-center float-right cursor-point sm-mt-30' onClick={() => reset()}>
                                    <img className='' src={'/assets/image/reset.png'} alt='' />
                                    <div className='fs-14 f-b color-3a3335 pl-10'>{strings.betting_line_reset}</div>
                                </div>
                            </div>
                            <div className='flex-full d-center mt-8'>
                                <div className='fs-16 sm-fs-14 color-3a3335 f-b'>{strings.expectant_gain_rate}</div>
                                <div className='fs-16 sm-fs-14 color-e45a5a flex-full text-right'>{string.Format(strings.format_pro, expectGainRate)}</div>
                            </div>
                        </div>
                    </div>
                    <div>

                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

